import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDesignateEmergencySavingsAccount = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	viewBox: "0 0 169 164",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_8040_53995)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M139.818 124.542C134.22 128.083 121.602 133.771 106.11 139.84C94.7714 144.266 81.897 148.885 69.0991 152.979C60.0269 155.888 50.9906 158.532 42.5739 160.664C16.3943 167.294 -4.29976 164.484 0.768265 144.055C8.21094 114.127 12.1208 98.1466 10.231 71.4329C8.76757 50.887 24.3397 42.4387 43.1305 44.8897C73.7047 48.8535 123.528 77.5468 134.463 84.774C150.618 95.4353 160.822 111.263 139.818 124.542Z",
				fill: "#DFE8FD"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M69.0946 152.979C81.8926 148.885 94.7669 144.266 106.106 139.84C97.1416 138.035 83.5176 136.886 68.2597 136.881C41.2586 136.881 19.375 140.473 19.375 144.93C19.375 147.386 26.0181 149.579 36.5 151.053L38 152.979L43 155.635L53.5 152.607C58.1568 152.848 63.1154 152.979 68.2597 152.979H69.0946Z",
				fill: "#2C64EF",
				fillOpacity: .5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.0547 75.2616C32.7104 74.5568 45.3962 74.3279 52.6189 85.7612C68.64 85.9139 81.0025 90.9505 91.0713 101.63C101.306 101.028 117.381 106.056 122.422 112.906C122.422 112.906 116.672 82.7267 104.017 72.6356C91.363 62.5444 64.3261 58.437 50.4687 61.0047C36.6113 63.5724 23.0547 75.2616 23.0547 75.2616Z",
				fill: "#2C64EF",
				fillOpacity: .5,
				stroke: "#2C64EF",
				strokeWidth: 1.58909,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M61.6563 151.3C60.7769 151.299 59.9338 150.949 59.312 150.327C58.6901 149.705 58.3402 148.862 58.339 147.982V143.911H57.8901C54.6551 143.876 51.4279 143.585 48.2389 143.04C47.4533 142.91 46.6273 142.744 45.7071 142.528L45.1639 142.403L45.1325 144.647C45.1329 145.03 45.0495 145.407 44.8882 145.754C44.7269 146.101 44.4916 146.408 44.1988 146.654C43.6598 147.098 42.9805 147.337 42.282 147.327C42.103 147.328 41.9243 147.313 41.7479 147.282L40.1273 147.026C39.3481 146.902 38.6358 146.512 38.112 145.922C37.5882 145.332 37.2851 144.578 37.2544 143.79V139.265L37.0389 139.13C31.4278 135.741 28.1104 130.494 27.1633 123.545L27.1184 123.208L26.7817 123.159C22.6878 122.566 20.1066 120.061 19.7071 116.286C19.6942 116.133 19.7129 115.979 19.762 115.833C19.8112 115.687 19.8898 115.553 19.9929 115.439C20.096 115.325 20.2215 115.233 20.3615 115.17C20.5015 115.106 20.6531 115.072 20.8069 115.07C20.9543 115.07 21.1 115.101 21.2345 115.162C21.3691 115.222 21.4895 115.31 21.588 115.42C22.0877 115.979 22.7051 116.421 23.3959 116.714C24.0866 117.006 24.8336 117.142 25.5831 117.112C25.9221 117.112 26.2608 117.092 26.5976 117.054L26.9612 117.013L26.9972 116.65C28.2451 104.013 38.6684 93.9265 52.2834 92.1265C54.5613 91.7931 56.8586 91.6086 59.1605 91.5743L59.3894 91.6103L59.5869 91.4576C60.157 90.883 60.7675 90.3085 61.405 89.7473C61.4675 89.6939 61.5471 89.6646 61.6294 89.6646C61.7117 89.6646 61.7913 89.6939 61.8539 89.7473C62.5921 90.3927 63.2949 91.0775 63.9592 91.7988L64.1208 91.9739L64.3542 91.9379H64.426C64.8749 91.9963 65.3238 92.0591 65.7727 92.131C68.8794 92.5892 71.8843 93.5776 74.6564 95.0533L74.8494 95.1565L75.0559 95.0667C77.2044 94.1619 79.4013 93.3766 81.6367 92.7145L81.7489 92.6786L83.4592 92.131C83.495 92.1266 83.5311 92.1266 83.5669 92.131C83.6398 92.1306 83.7108 92.1543 83.7689 92.1983C83.8128 92.2304 83.8487 92.2722 83.8736 92.3205C83.8985 92.3688 83.9119 92.4223 83.9126 92.4766C83.8901 96.0678 83.4412 99.0619 82.5389 101.634L82.4581 101.854L82.5973 102.047C84.2851 104.399 85.6176 106.987 86.5521 109.728L86.6553 110.028H92.2934C93.0003 110.028 93.6981 110.188 94.335 110.494C94.972 110.801 95.5318 111.247 95.9729 111.799C96.414 112.351 96.7251 112.996 96.8831 113.685C97.0411 114.374 97.042 115.089 96.8856 115.779L96.1943 118.813C95.8596 120.323 95.1307 121.717 94.082 122.853C93.0332 123.989 91.702 124.827 90.224 125.282L89.9906 125.354L89.9278 125.592C88.5757 130.949 85.2506 135.598 80.6177 138.61L80.4157 138.74V143.646C80.4051 144.375 80.1333 145.076 79.6497 145.621C79.1661 146.166 78.5029 146.52 77.7807 146.618L76.3083 146.788C76.1876 146.803 76.0662 146.81 75.9447 146.811C75.2862 146.814 74.6486 146.58 74.1491 146.151C73.8732 145.906 73.6534 145.604 73.5047 145.266C73.356 144.929 73.2818 144.563 73.2872 144.194V141.949L72.7171 142.111C71.2892 142.506 69.8399 142.819 68.3763 143.049L67.3304 143.197L66.7244 143.283V147.987C66.7232 148.867 66.3727 149.711 65.7499 150.333C65.127 150.955 64.2828 151.304 63.4025 151.304L61.6563 151.3Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M87.0029 121.309C86.4372 121.309 86.2801 120.412 86.3654 119.64C86.5407 118.429 86.788 117.23 87.1061 116.048C87.3709 115.097 88.0039 114.28 88.4887 114.28C88.9735 114.28 89.2339 115.079 89.1082 116.026C88.9266 117.269 88.6626 118.499 88.3181 119.707C88.0802 120.367 87.564 121.305 87.0029 121.309Z",
				fill: "#2C64EF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M90.8508 121.265C90.2942 121.265 90.1461 120.394 90.2493 119.604C90.4394 118.393 90.7002 117.194 91.0304 116.013C91.3087 115.07 91.9282 114.258 92.4175 114.258C92.9068 114.258 93.1447 115.052 93.0055 115.991C92.8095 117.227 92.5321 118.449 92.1751 119.649C91.9282 120.331 91.4075 121.261 90.8508 121.265Z",
				fill: "#2C64EF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M85.3203 110.352H92.3096C92.9646 110.352 93.6113 110.499 94.2015 110.783C94.7918 111.067 95.3106 111.481 95.7193 111.992C96.1281 112.504 96.4164 113.102 96.5628 113.74C96.7092 114.378 96.71 115.042 96.5651 115.68L95.8738 118.715C95.445 120.598 94.39 122.279 92.8815 123.484C91.373 124.689 89.5001 125.347 87.5693 125.35",
				stroke: "#2C64EF",
				strokeWidth: 1.58909,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M44.8896 138.879L44.8178 144.652C44.8178 146.205 43.4083 147.242 41.7923 146.982L40.1717 146.726C39.4638 146.614 38.8164 146.26 38.3394 145.725C37.8625 145.19 37.5852 144.506 37.5547 143.79V136.392",
				stroke: "#2C64EF",
				strokeWidth: 1.52175,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M66.3636 139.97V147.983C66.3636 148.772 66.05 149.529 65.4919 150.087C64.9338 150.645 64.1768 150.959 63.3874 150.959H61.6592C61.2686 150.959 60.8818 150.882 60.5209 150.732C60.1601 150.582 59.8323 150.363 59.5563 150.087C59.2803 149.81 59.0615 149.482 58.9124 149.121C58.7633 148.76 58.6869 148.373 58.6875 147.983V140.571",
				stroke: "#2C64EF",
				strokeWidth: 1.58909,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M80.183 138.461V143.646C80.1702 144.316 79.9191 144.959 79.4748 145.46C79.0305 145.961 78.4221 146.287 77.7589 146.38L76.2596 146.564C75.9194 146.62 75.5709 146.601 75.2387 146.509C74.9065 146.416 74.5985 146.252 74.3363 146.028C74.0742 145.804 73.8642 145.525 73.7211 145.212C73.578 144.898 73.5052 144.557 73.5079 144.212V141.64",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M58.5485 143.57C55.1122 143.576 51.6818 143.284 48.2957 142.699C47.1765 142.517 46.0961 142.292 45.0547 142.026",
				stroke: "#2C64EF",
				strokeWidth: 1.58909,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M89.6467 125.349C86.9982 135.346 79.3221 140.962 68.3018 142.699C67.6509 142.802 67.0179 142.892 66.3984 142.977",
				stroke: "#2C64EF",
				strokeWidth: 1.58909,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M76.9581 111.398C75.9525 111.398 75.6114 110.424 75.4318 109.643C75.2654 108.401 75.3867 107.137 75.7864 105.949C76.15 105.051 76.783 104.193 77.6493 104.193C78.5157 104.193 79.005 105.042 79.1756 105.94C79.2906 107.182 79.1703 108.436 78.821 109.634C78.5561 110.321 77.9591 111.398 76.9581 111.398Z",
				fill: "#2C64EF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M85.6332 111.398C84.6322 111.398 84.2866 110.424 84.1115 109.643C83.945 108.401 84.0664 107.137 84.4661 105.949C84.8297 105.051 85.4627 104.193 86.3246 104.193C87.1864 104.193 87.7027 105.042 87.8508 105.949C87.9681 107.191 87.8478 108.445 87.4962 109.643C87.2134 110.321 86.6388 111.398 85.6332 111.398Z",
				fill: "#2C64EF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M54.4688 99.4616C55.9546 95.9513 58.437 92.8359 61.6511 90.0034C64.3926 92.43 66.6736 95.3315 68.3845 98.5683",
				stroke: "#2C64EF",
				strokeWidth: 1.58909,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M75 95.4712C77.4016 94.3579 80.5394 93.4466 83.5874 92.4546C83.5874 95.8572 83.1385 99.0219 82.1284 101.805",
				stroke: "#2C64EF",
				strokeWidth: 1.58909,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M64.4141 92.2749C64.863 92.3333 65.2849 92.3961 65.7383 92.4679C76.4265 94.1378 83.2452 100.737 86.4324 110.352",
				stroke: "#2C64EF",
				strokeWidth: 1.58909,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M37.4512 138.987C30.848 135.104 27.2344 128.6 27.2344 119.236C27.2344 105.621 37.7789 94.3848 52.3725 92.4635C54.6312 92.1344 56.9089 91.9514 59.1912 91.9159",
				stroke: "#2C64EF",
				strokeWidth: 1.58909,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M48.617 106.756C48.4289 106.741 48.2398 106.764 48.061 106.824C47.8823 106.884 47.7177 106.981 47.5774 107.107C47.437 107.233 47.3239 107.386 47.2448 107.557C47.1658 107.729 47.1225 107.914 47.1176 108.103L47.0638 109.696C43.4322 109.835 41.3673 111.941 41.2775 114.54C41.1384 118.58 45.0572 119.693 47.8763 120.551C49.7347 121.134 50.8884 121.646 50.8569 122.642C50.83 123.482 49.8245 124.03 48.2937 123.863C46.8334 123.7 45.441 123.158 44.2537 122.292C43.8511 121.992 43.3501 121.855 42.8507 121.908C42.3513 121.961 41.8905 122.201 41.5603 122.58C41.3936 122.809 41.2747 123.07 41.2107 123.346C41.1467 123.622 41.139 123.909 41.188 124.188C41.237 124.467 41.3418 124.734 41.4959 124.972C41.6501 125.21 41.8506 125.415 42.0855 125.574C43.4039 126.483 44.8952 127.111 46.4667 127.419L46.4219 128.676C46.4182 129.071 46.5589 129.454 46.8176 129.753C47.0762 130.053 47.4351 130.247 47.8269 130.301C48.0117 130.329 48.2004 130.317 48.3803 130.267C48.5603 130.216 48.7274 130.128 48.8706 130.008C49.0137 129.887 49.1296 129.738 49.2105 129.569C49.2914 129.401 49.3354 129.217 49.3397 129.03L49.3801 127.764C53.2675 127.764 55.4536 125.816 55.5569 122.633C55.687 118.629 51.6201 117.399 48.7247 116.528C46.7989 115.99 45.744 115.581 45.7754 114.675C45.7754 113.925 46.3904 113.382 47.8763 113.507C49.1368 113.639 50.3518 114.051 51.4315 114.715C51.8386 114.966 52.3208 115.066 52.7941 114.998C53.2674 114.93 53.7018 114.698 54.0216 114.342C54.2179 114.107 54.3593 113.831 54.4356 113.534C54.5119 113.237 54.5211 112.927 54.4627 112.626C54.4042 112.325 54.2795 112.041 54.0976 111.795C53.9158 111.548 53.6813 111.345 53.4112 111.2C52.3417 110.596 51.1823 110.167 49.9771 109.93L50.031 108.296C50.0376 107.907 49.8946 107.53 49.6314 107.244C49.3683 106.957 49.0051 106.782 48.617 106.756Z",
				fill: "#2C64EF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M27.1525 117.341C24.8766 117.682 22.9553 117.399 21.3483 115.653C21.2399 115.539 21.0982 115.462 20.9435 115.433C20.7887 115.405 20.6288 115.426 20.4867 115.494C20.3447 115.561 20.2277 115.672 20.1527 115.811C20.0776 115.949 20.0483 116.108 20.0689 116.264C20.5178 120.331 23.5748 122.503 27.2916 122.894",
				stroke: "#2C64EF",
				strokeWidth: 1.58909,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M89.4302 54.6982L47.0949 150.241C46.8134 150.881 46.408 151.458 45.9022 151.94C45.3964 152.422 44.8001 152.799 44.1479 153.049C43.4956 153.3 42.8002 153.418 42.1018 153.399C41.4034 153.379 40.7158 153.221 40.0787 152.934V152.934C39.4304 152.641 38.8479 152.22 38.3661 151.696C37.8843 151.172 37.5131 150.557 37.2747 149.886C37.0362 149.216 36.9355 148.504 36.9784 147.794C37.0213 147.083 37.207 146.389 37.5245 145.752L38.952 142.893",
				stroke: "#2C64EF",
				strokeWidth: 4.48895,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M92.4219 52.3594C101.768 60.5517 105.44 77.0486 101.193 88.6705L101.642 88.8815C109.363 92.5759 114.629 99.0983 118.996 106.088C120.278 108.208 121.432 110.402 122.453 112.659C123.099 98.3352 120.428 81.9999 113.39 70.0144C108.645 61.9568 102.432 56.4309 93.6922 52.8038C93.3017 52.6512 92.8528 52.521 92.4219 52.3594Z",
				fill: "white",
				stroke: "#2C64EF",
				strokeWidth: 1.50829,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M91.3657 51.9912C76.9696 50.842 62.6364 57.1445 56.1364 70.4632L55.6516 70.3195C47.3381 67.8506 38.2973 69.7629 30.5135 72.3485C28.0056 73.2248 25.5583 74.2655 23.1875 75.4639C32.4123 63.1282 45.5919 52.8665 60.8004 50.218C70.4831 48.5302 80.4934 48.4853 90.0953 51.5647C90.5128 51.6904 90.9437 51.8385 91.3657 51.9912Z",
				fill: "white",
				stroke: "#2C64EF",
				strokeWidth: 1.50829,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M101.157 88.5758C95.1684 80.1142 90.6794 76.2178 82.3614 72.8196C74.4564 69.5831 68.2122 69.0624 57.2233 70.0634C56.8676 70.142 56.5225 70.2625 56.1953 70.4225C56.2851 70.216 56.3794 70.0095 56.4781 69.7986C62.2778 57.7143 75.5562 51.4612 88.5472 51.9505C89.647 51.9909 90.7917 52.0448 91.8914 52.1525C92.8539 52.8758 93.7547 53.6776 94.5848 54.5496C102.589 62.9843 105.134 77.7171 101.157 88.5758Z",
				fill: "white",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M153.812 34.3946L163.58 24.3394",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M120.688 68.4927L149.376 38.9644",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M125.422 88.9887L168.314 44.8398",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M70.1328 26.1976L86.9484 8.88818",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M44.0625 53.0413L60.721 35.8936",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M130.75 38.4388L158.846 9.521",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M115.961 53.6701L124.355 45.0244",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M114.867 26.4537L138.668 1.94849",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M95.7734 46.1016L106.331 35.2339",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M101.703 53.7238L129.023 25.1382",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M77.1719 44.8403L120.064 0.687012",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M134.742 97.5586C136.337 99.0006 137.483 100.87 138.046 102.945",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M125.203 94.7164C126.572 94.5039 127.967 94.5374 129.324 94.8152",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M29.5934 50.3706C27.9937 50.5294 26.4354 50.9733 24.9922 51.6814",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M38.9941 54.6977C38.0245 52.5655 35.9955 51.1874 33.5625 50.6128",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M35.6833 40.8896C33.9371 39.3409 31.7375 38.4117 29.3359 38.7439",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M39.6007 48.1665C39.4101 46.819 38.9847 45.5154 38.3438 44.3149",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_8040_53995",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 169,
			height: 163.865,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgDesignateEmergencySavingsAccount);
export { ForwardRef as ReactComponent };
